// extracted by mini-css-extract-plugin
export default {"discountBanner":"EN","topheader":"FN","navleft":"GN","navflexelem":"HN","navright":"IN","fixedtop":"JN","checkout_header_wrapper":"KN","hideBanner":"LN","abstop":"MN","subdesc":"NN","smallscreennav":"ON","nav_hidden":"PN","cancel_link":"QN","bottomnavcontainer":"RN","fixedbottom":"SN","animatedbottom":"TN","appear-bottom":"UN","delayedbottom":"VN","long_banner":"WN","nofixed":"XN","black_friday":"YN"};
    if(module.hot) {
      // 1715091680321
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  